import BrandLogo from "../components/BrandLogo";
import loginBg from "../assets/admin.png";

/* Cadre commun aux pages publiques de l'espace organisation.

   Reprend le panneau de l'espace administrateur : la photo des Comores,
   le voile dégradé, le serif du titre et la barre ambre. Deux espaces
   partagent la même entrée, donc ils doivent se ressembler. Seul le
   discours change, parce que l'interlocuteur n'est pas le même : un
   hébergeur gère ses chambres, une organisation gère des gens. */
export default function OrgAuthShell({ titre, sousTitre, children, pied }) {
  return (
    <div className="org-shell min-h-screen flex">

      {/* ── Panneau gauche ─────────────────────────────── */}
      <div
        className="hidden lg:flex flex-col w-[46%] max-w-[560px] shrink-0 p-12 relative overflow-hidden"
        style={{
          backgroundImage: `url(${loginBg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      >
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            background:
              "linear-gradient(180deg, rgba(15,40,10,0.30) 0%, rgba(15,40,10,0.10) 40%, rgba(15,40,10,0.55) 100%)",
          }}
        />

        <div className="relative z-10">
          <BrandLogo variant="horizontal" height={44} light />
        </div>

        <div className="relative z-10 flex-1 flex flex-col justify-center max-w-[400px]">
          <p
            className="text-xs font-bold tracking-[0.2em] uppercase mb-4"
            style={{ color: "var(--k-sun)" }}
          >
            Espace organisation
          </p>
          <h1
            className="text-white text-[2.4rem] font-bold leading-[1.12]"
            style={{ fontFamily: "Georgia, serif", textShadow: "0 2px 14px rgba(0,0,0,0.4)" }}
          >
            Vos équipes partent, votre organisation règle.
          </h1>
          <p
            className="text-white/80 text-[15px] mt-5 leading-relaxed"
            style={{ textShadow: "0 1px 8px rgba(0,0,0,0.4)" }}
          >
            Une facture à votre nom, un suivi par personne,<br />
            et l'établissement prévenu de la prise en charge.
          </p>
          <div className="mt-7 h-1 w-14 rounded-full" style={{ background: "var(--k-sun)" }} />
        </div>

        <div className="relative z-10">
          <p className="text-white/50 text-xs">© {new Date().getFullYear()} Komorotel</p>
        </div>
      </div>

      {/* ── Panneau droit ──────────────────────────────── */}
      <div className="flex-1 flex items-center justify-center bg-white p-6 sm:p-10">
        <div className="w-full max-w-md komo-fade">

          <div className="lg:hidden flex justify-center mb-8">
            <BrandLogo variant="horizontal" height={38} />
          </div>

          <h2 className="text-[26px] font-bold text-gray-900 leading-tight">{titre}</h2>
          {sousTitre && <p className="text-sm text-gray-500 mt-1.5">{sousTitre}</p>}

          <div className="mt-8">{children}</div>

          {pied && <div className="mt-8 text-sm text-gray-500">{pied}</div>}
        </div>
      </div>

      <style>{`
        @keyframes komoFadeIn { from {opacity:0; transform: translateY(6px);} to {opacity:1; transform:none;} }
        .komo-fade { animation: komoFadeIn .4s ease; }
        @media (prefers-reduced-motion: reduce) { .komo-fade { animation: none; } }
      `}</style>
    </div>
  );
}

/* Champ encadré, comme dans l'espace administrateur : même forme, même
   libellé en petites capitales, pour que les deux entrées se répondent. */
export function Champ({ label, type = "text", value, onChange, required, aide, icone, droite }) {
  return (
    <div>
      <label className="block text-xs font-bold text-gray-500 mb-2 uppercase tracking-wide">
        {label}
      </label>
      <div className="relative">
        {icone && (
          <span className="absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
            {icone}
          </span>
        )}
        <input
          type={type}
          value={value}
          required={required}
          onChange={e => onChange(e.target.value)}
          className={`w-full ${icone ? "pl-11" : "pl-4"} ${droite ? "pr-11" : "pr-4"} py-3 text-[15px]
            border border-gray-200 rounded-xl outline-none text-gray-900
            focus:border-[var(--k-green)] focus:ring-2 focus:ring-[rgb(var(--k-green-rgb)/0.1)] transition`}
        />
        {droite && (
          <span className="absolute right-3.5 top-1/2 -translate-y-1/2">{droite}</span>
        )}
      </div>
      {aide && <p className="text-xs text-gray-400 mt-1.5">{aide}</p>}
    </div>
  );
}

export function BoutonPrincipal({ children, ...props }) {
  return (
    <button
      {...props}
      className="w-full py-3 rounded-xl text-[15px] font-bold text-white transition hover:opacity-90 disabled:opacity-50"
      style={{ background: "var(--k-green)" }}
    >
      {children}
    </button>
  );
}
